"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.large = exports.medium = exports.small = void 0;
var _core = require("@emotion/core");
const small = () => (0, _core.css)`
  border-radius: 4px;
`;
exports.small = small;
const medium = () => (0, _core.css)`
  border-radius: 8px;
`;
exports.medium = medium;
const large = () => (0, _core.css)`
  border-radius: 16px;
`;
exports.large = large;